import { HeaderService } from "@app/components/header/header.service";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { RegistrationStore } from "./stores/RegistrationStore";
import { CreateAccountInfo } from "@app/pages/registration/createAccount.component";
import { Property } from "@app/models/Property";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";
import { MatDialog } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { TermsDialog } from "@app/pages/registration/terms.dialog";
import { PersonalInfoData } from "@app/components/personalInfo/personalInfo.directive";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-registration',
    template: require('./registration.html')
})
export class RegistrationComponent implements OnInit {

    @ViewChild('registrationForm') private registrationForm: NgForm;

    viewedTc = false;
    optIn = true;
    invalidCheckVar: boolean = false;
    terms: string;

    accountInfo: CreateAccountInfo;
    property: Property
    personalInfoData: PersonalInfoData = {} as PersonalInfoData;

    $stateParams: any;

    constructor(
        @Inject(WindowToken) private $window: Window,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(RegistrationStore) private registrationStore: RegistrationStore,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute,
    ) {
        headerService.setDisplayRightContent(false);

        this.$stateParams = this.route.snapshot.queryParams;

        this.personalInfoData.useAnonymousApi = true;
        this.personalInfoData.registration = true;
    }

    ngOnInit() {

        // retrieve the homeowner to setup or try to pull from URL parameters
        if (this.registrationStore.getHomeowner() != null) {
            this.personalInfoData.homeowner = this.registrationStore.getHomeowner();
        } else if (this.guestPaymentStore.getHomeowner() != null) {
            this.personalInfoData.homeowner = this.guestPaymentStore.getHomeowner();
            this.registrationStore.setHomeowner(this.personalInfoData.homeowner)
        } else if (this.$stateParams) {

            if (this.$stateParams.first ||
                this.$stateParams.last ||
                this.$stateParams.email ||
                this.$stateParams.phonenum) {
                this.personalInfoData.homeowner = {
                    id: null,
                    version: null,
                    firstName: this.$stateParams.first ? this.$stateParams.first : null,
                    lastName: this.$stateParams.last ? this.$stateParams.last : null,
                    contactInformation: {
                        email: {
                            value: this.$stateParams.email ? this.$stateParams.email : null
                        },
                        phones: [
                            {
                                type: "",
                                countryCallingCode: "USA",
                                value: this.$stateParams.phonenum ? this.$stateParams.phonenum : ""
                            }
                        ],
                        notifyBySms: false
                    }
                };
                this.registrationStore.setHomeowner(this.personalInfoData.homeowner);
            }

            if (this.$stateParams.managementCouponId ||
                this.$stateParams.associationCouponId ||
                this.$stateParams.propertyCouponId) {
                this.property = {
                    couponId: this.$stateParams.propertyCouponId ? this.$stateParams.propertyCouponId : null,
                    hoa: {
                        couponId: this.$stateParams.associationCouponId ? this.$stateParams.associationCouponId : null,
                        pmc: {
                            couponId: this.$stateParams.managementCouponId ? this.$stateParams.managementCouponId : null
                        }
                    }
                };
                this.registrationStore.setProperty(this.property);
            }

            if (this.$stateParams.username) {
                this.accountInfo = {
                    username: this.$stateParams.username,
                    firstName: null,
                    lastName: null,
                    emailaddress: null,
                    confirmEmailAddress: null,
                    password: null,
                    confirmPassword: null,
                    optIn: null,
                    passwordStrength: null,
                    phone: null
                };
                this.registrationStore.setAccountInfo(this.accountInfo);
            }

        }

        if (this.guestPaymentStore.getViewedTc()) {
            this.registrationStore.setViewedTc(true);
            this.guestPaymentStore.setViewedTc(false);
        }

        if (this.guestPaymentStore.getProperty() != null) {
            this.registrationStore.setProperty(this.guestPaymentStore.getProperty());
        }

        if (!this.personalInfoData.homeowner) {
            this.personalInfoData.homeowner = {
                firstName: "",
                lastName: "",
                id: null,
                version: null,
                contactInformation: {
                    email: {
                        value: ""
                    },
                    phones: [
                        {
                            type: "",
                            countryCallingCode: "USA",
                            value: ""
                        }
                    ],
                    notifyBySms: false
                }
            };
        }

        if (!this.viewedTc && !this.registrationStore.getViewedTc()) {
            const dialogRef = this.dialog.open(TermsDialog);
            dialogRef.afterClosed().pipe(take(1)).subscribe({
                next: value => {
                    if (value === 'Y') {
                        this.registrationStore.setViewedTc(true);
                        this.viewedTc = true;
                    } else {
                        this.$window.location.replace(this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL);

                    }
                },
                error: () => {} })
        }
    }

    emailAddressValid(invalidObj) {
        for (let key in invalidObj) {
            if (invalidObj[key]) {
                this.invalidCheckVar = true;
                return;
            }
        }
        this.invalidCheckVar = false;
    }

    isPhoneNumberValid() {
        if (this.personalInfoData.homeowner.contactInformation.phones && this.personalInfoData.homeowner.contactInformation.phones.length > 0) {
            if (this.personalInfoData.homeowner.contactInformation.phones[0].countryCallingCode === 'USA')
                return this.personalInfoData.homeowner.contactInformation.phones[0].value.replace(/[^0-9]+/g, '').length === 10;
            else if (this.personalInfoData.homeowner.contactInformation.phones[0].countryCallingCode !== 'USA')
                return this.personalInfoData.homeowner.contactInformation.phones[0].value.replace(/[^0-9]+/g, '').length >= 7;
        }
        return false;
    }

    cancel() {
        this.registrationStore.clearAllData();
        this.$window.location.replace(this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL);
    }

    submit() {
        this.registrationStore.setHomeowner(this.personalInfoData.homeowner);

        this.registrationStore.setMarketingAgreement(this.optIn)
        this.router.navigateByUrl('/registerStep2');
    }
}
